<template>
    <div>
        <header class="header-with-buttons">
            <h2 class="display-6 project-block-header">{{ projectblockdata.Name }}</h2>
            <button class="button" @click="showModal = true">Invite</button>
        </header>
        
        <p class="display-7" v-if="projectblockdata.Description">{{ projectblockdata.Description }}</p>
        
        <todo-list title="Needs" setname="Needs" showCheckboxes="true" class="card card-shadow padded needs-list"/>

        <todo-list title="Success items" setname="Items" showCheckboxes="true" class="card card-shadow padded"/>
        
        
        <modal v-if="showModal" @close="showModal = false" title="Invite members">
            <form @submit.prevent="addMember">
                <transition name="fade">
                    <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
                </transition>
                <input-default label="Username" v-model="inviteUsername"/>
                <input-default label="Email" v-model="inviteEmail"/>
                <input-default label="Password" v-model="invitePass"/>
                <button class="button" type="submit">Invite</button>
            </form>
        </modal>
    </div>
</template>

<script>
    import TodoList from '../todo/TodoList.vue'
    import InputDefault from '../form/InputDefault.vue'
    import Modal from '../modal/Modal.vue'
    import axios from 'axios'

    export default {
        components: {
            TodoList,
            Modal,
            InputDefault
        },
        data: function(){
            return{
                msgtext: '',
                msgclass: '',
                showModal: false,
                projectblockdata: {},
                inviteUsername: '',
                inviteEmail: '',
                invitePass: '',
                addedUser: {},
                token: JSON.parse(localStorage.getItem('user')).id
            }
        },
        methods: {
            getProjectBlockData(){

                axios.get(process.env.VUE_APP_ROOT_API+'/Projects/'+this.$route.params.projectid+'/ProjectBlocks/'+this.$route.params.projectblockid+'?access_token='+this.token)
                .then(response => {
                    this.projectblockdata = response.data
                    this.loading = false
                })
            },
            addMember(){
                const data = {
                    username: this.inviteUsername,
                    email: this.inviteEmail,
                    password: this.invitePass
                }

                axios.post(process.env.VUE_APP_ROOT_API+'/Members?access_token='+this.token, data)
                .then(response => {
                    this.addedUser = response.data
                    this.addMemberToProject(this.addedUser.id)
                })
            },
            addMemberToProject(memberId){

                const data = {
                    memberId: memberId,
                    projectId: this.projectblockdata.ProjectId
                }

                axios.post(process.env.VUE_APP_ROOT_API+'/ProjectMembers?acces_token='+this.token, data)
                .then(response => {
                    console.log(response.data)
                })
            }
        },
        mounted(){
            this.getProjectBlockData()
        },
        watch: {
            '$route' (to, from) {
                this.getProjectBlockData()
            }
        }
    }
</script>

<style lang="scss">
    .project-block-header{
        margin-top: 10px;
    }
    .needs-list{
        margin: 3rem 0;
    }
</style>
